// extracted by mini-css-extract-plugin
export var actions = "AdminActionConfirmationModal-module__actions___oabXf";
export var avatar = "AdminActionConfirmationModal-module__avatar___Gs6UP";
export var busyOverlay = "AdminActionConfirmationModal-module__busyOverlay___5MEpC";
export var close = "AdminActionConfirmationModal-module__close___WUB0y";
export var description = "AdminActionConfirmationModal-module__description___BjQIb";
export var destructiveButton = "AdminActionConfirmationModal-module__destructiveButton___fVlBu";
export var detail = "AdminActionConfirmationModal-module__detail___N0IXu";
export var email = "AdminActionConfirmationModal-module__email___bZJ9B";
export var header = "AdminActionConfirmationModal-module__header___eicD2";
export var identity = "AdminActionConfirmationModal-module__identity___xfV1v";
export var memberCard = "AdminActionConfirmationModal-module__memberCard___iLjWz";
export var modalBody = "AdminActionConfirmationModal-module__modalBody___LZWLF";
export var name = "AdminActionConfirmationModal-module__name___KLFuC";
export var title = "AdminActionConfirmationModal-module__title___B2zm7";